import { ReactNode } from "react";
import { Link } from "react-router";
import { useShellRootPath } from "../../hooks";
import { Logo as CommonLogo, Tooltip } from "capitalrx-components-2.0/lib/general";
import * as Color from "capitalrx-components-2.0/lib/general/Color";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { EnvironmentTag } from "../EnvironmentTag";
import styled from "styled-components";

// TODO: remove logo ID when no longer a required property.

const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: auto;
    height: 1.5rem;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    svg {
      path {
        fill: ${Color.toString(Color.Turqoise[100])};
      }
    }
  }
`;

/** The menu bar logo component. */
export const Logo = (): ReactNode => {
  const rootPath = useShellRootPath();

  /** do not change data-testid value below as it will break PDF lambda (capitalrx_pdf_generation),
   * if you plan on changing it, update selectors in PDF lambda as well **/
  return (
    <Tooltip content="Dashboard">
      {(ref) => (
        <Shelf spacing="medium">
          <LogoLink ref={ref} className="logo" to={rootPath} data-testid="test__applicationHomeButton" tabIndex={3}>
            <CommonLogo name="judi-white-knockout-horizontal" />
          </LogoLink>
          <EnvironmentTag />
          <Shelf.Spacer />
        </Shelf>
      )}
    </Tooltip>
  );
};
